import yup from 'yup';
// translate
import messages from './messages';

export default yup.object({
  login: yup.string().required(messages.validationRequiredLogin),
  email: yup
    .string()
    .required(messages.validationRequiredEmail)
    .email(messages.validationEmail),
  password: yup
    .string()
    .min(8, messages.validationMinLengthPassword)
    .required(messages.validationRequiredPassword),
});



// WEBPACK FOOTER //
// ./src/components/Signup/formRules.js